export default "__VITE_ASSET__CsfnJUsc__"